package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebSkeletonRow
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.dom.Div

@Composable
fun AdminSkeletonRow(heightPx: Int = 16, widthFraction: Double = 1.0) {
    WebSkeletonRow(heightPx = heightPx, widthFraction = widthFraction)
}

@Composable
fun AdminSkeletonCard() {
    AdminCard {
        AdminSkeletonRow(heightPx = 14, widthFraction = 0.4)
        Div({ style { height(HandpassSpacing.SM) } })
        AdminSkeletonRow(heightPx = 30, widthFraction = 0.7)
    }
}

@Composable
fun AdminSkeletonTable(rows: Int = 6) {
    repeat(rows) {
        Div({
            style {
                padding(HandpassSpacing.Default, HandpassSpacing.XL)
            }
        }) { AdminSkeletonRow(heightPx = 18, widthFraction = 1.0) }
    }
}
